import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    clientList: [],
    clientView: null,
    clientEdit: null,
    clientAll: [],
    clientDropdown: []
};

export const clientSlice = createSlice({
    name: "client",
    initialState,
    reducers: {
        getClient: (state,{payload}) => {
            state.clientList = payload;
        },
        setClientList: (state, { payload }) => {
            state.clientList = payload;
        },
        setClientView: (state, { payload }) => {
            state.clientView = payload;
        },
        setClientEdit: (state, { payload }) => {
            state.clientEdit = payload;
        },
        setClientAll: (state, { payload }) => {
            state.clientAll = payload;
        },
        setClientDropdown: (state, { payload }) => {
            state.clientDropdown = payload;
        }
    }
});

export const {
    getClient,
    setClientList,
    setClientView,
    setClientEdit,
    setClientAll,
    setClientDropdown
} = clientSlice.actions;

export default clientSlice.reducer;
